import React from "react";
import "./Skills.css";

function Skills() {
  const skills = [
    "React",
    "JavaScript (ES6+)",
    "Tailwind",
    "Node.js",
    "Express.js",
    "MongoDB",
    "SQL",
    "Figma",
    "Git & GitHub",
  ];

  return (
    <section id="skills" className="skills-section py-5">
      <div className="container">
        <h2 className="text-center mb-4">Skills</h2>
        <div className="row justify-content-center">
          {skills.map((skill) => (
            <div key={skill} className="col-md-3 col-sm-6 mb-3">
              <div className="skill-card text-center">{skill}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;
